export const risksArray = [
    {
        name: 'Медицинские услуги',
        tooltip: (
            <div>
                Диагностика и лечение злокачественных новообразований:
                <ul>
                    <li>Оплачиваются все основные этапы лечения онкологии —от
                        консультаций врачей, анализов и обследований до операций, химио-,
                        лучевой и гормональной терапии, ухода в стационаре, а также
                        психологическая помощь и наблюдение после лечения.</li>
                </ul>
                Трансплантация костного мозга
                <ul>
                    <li>
                        Оплачивается поиск донора, сама операция по пересадке
                        костного мозга, работа хирурга, а также лечение и обследования в
                        больнице до и после трансплантации
                    </li>
                </ul>
            </div>
        )
    },
    {
        name: 'Транспортные расходы',
        tooltip: (
            <div>
                <ul>
                    <li>Оплачивается дорога для пациента (и одного сопровождающего)
                        до места лечения и обратно —трансфер, авиабилеты, а также поездки
                        на такси между отелем и клиникой.</li>
                    <li>Оплачивается доставка (поиск, хранение и перевозка)
                        донорского костного мозга.</li>
                </ul>
            </div>
        )
    },
    {
        name: 'Проживание',
        tooltip: (
            <div>
                <ul>
                    <li>Оплачивается проживание в 3-4 звездном отеле с завтраком на время лечения — для пациента и одного сопровождающего.</li>
                </ul>
            </div>
        )
    },
    {
        name: 'Оплата медикаментов и материалов',
        tooltip: (
            <div>
                Диагностика и лечение злокачественных новообразований:
                <ul>
                    <li>Оплачиваются лекарства и расходные материалы, необходимые для лечения и обследований — как в стационаре, так и амбулаторно, включая переливание крови и установку имплантов.</li>
                </ul>
                Трансплантация костного мозга:
                <ul>
                    <li>Оплачиваются лекарства и расходные материалы, которые нужны пациенту во время госпитализации по поводу трансплантации костного мозга — до операции и в течение длительного восстановления после неё.</li>
                </ul>
            </div>
        )
    },
    {
        name: 'Репатриация',
        tooltip: (
            <div>
                <ul>
                    <li>Оплачивается перевозка тела до ближайшего к дому аэропорта, в случае смерти застрахованного или его сопровождающего во время поездки на лечение.</li>
                </ul>
            </div>
        )
    },
    {
        name: 'Сопутствующие услуги',
        tooltip: (
            <div>
                <ul>
                    <li>Визовая поддержка в оформлении документов для поездки на лечение.</li>
                    <li>Устный и письменный перевод в медицинском учреждении во время лечения.</li>
                </ul>
            </div>
        )
    }
];